module.exports = __webpack_public_path__ + "static/img/carbonCal.a6f03ab0.png";